<template>
  <div class="py-3 h-100">
    <p :class="{ 'text-danger': invalidFields.includes('datetime') }">Memo</p>
    <!-- <div class="w-100 h-100" v-if="memo">
      <iframe
        v-if="memo.attachment"
        :src="memo.attachment.url"
        class="w-100 h-100"
        frameborder="0"
      />
    </div> -->
    <div
      class="image-grid image-grid-placeholder border-0 bg-dark"
      v-if="memo && memo.attachment"
    >
      <button
        class="btn btn-dark h-100 w-100 lh-sm"
        @click="currentPdf = memo.attachment.url"
      >
        <i class="fa-solid fa-file-pdf fa-2x mb-2 d-block" />
        Click to view
      </button>
    </div>

    <div class="w-100 h-100" v-if="!memo">
      <div v-if="filePreview" class="w-100 py-3 d-flex justify-content-end">
        <button class="btn btn-success mx-1" @click="submitMemo">Submit</button>
        <button class="btn btn-secondary mx-1" @click="cancelAttachment">
          Cancel
        </button>
      </div>

      <div class="image-grid image-grid-placeholder" v-if="!filePreview">
        <button class="btn h-100 w-100 fw-bold lh-sm" @click="addImage()">
          <i class="fa-solid fa-plus fa-2x mb-2 d-block" />
          Add Memo File
        </button>
      </div>

      <div class="image-grid image-grid-placeholder border-0 bg-dark" v-else>
        <button
          class="btn btn-dark h-100 w-100 lh-sm"
          @click="currentPdf = filePreview"
        >
          <i class="fa-solid fa-file-pdf fa-2x mb-2 d-block" />
          Click to preview
        </button>
      </div>
    </div>

    <pdf-viewer
      :url="currentPdf"
      v-if="currentPdf"
      @close="currentPdf = null"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import PdfViewer from "@/components/PdfViewer";
import AddMaterialForm from "@/components/AddMaterialForm";

export default {
  props: ["componentId", "nodStatus", "nodId", "caseId"],
  components: { AddMaterialForm, PdfViewer },
  data() {
    return {
      memo: null,
      memoId: null,
      filePreviews: [],
      fileInput: null,
      filePreview: null,
      invalidFields: [],
      currentPdf: null,
    };
  },
  methods: {
    cancelAttachment() {
      this.fileInput = null;
      if (this.filePreview) URL.revokeObjectURL(this.filePreview);
      this.filePreview = null;
      this.Helper.removeToast("Memo PDF removed");
    },
    submitMemo() {
      Swal.fire({
        icon: "question",
        title: "<h5 class='fw-bold'>Submit Memo data?</h5>",
        html: "<p class='mb-0'>This action is not reversible.<br />Data cannot be changed after it is submitted.</p>",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "Confirm",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.Helper.toggleLoadingSpinner(true);

          let _nodId = this.nodId;

          if (!_nodId) {
            const [call, error] = await this.Helper.handlePromise(
              this.API.post("nod-cases", {
                case: this.caseId,
              })
            );

            if (error) {
              console.error(error);

              this.triggerAlert("error", error);
            } else {
              _nodId = call.data._id;
            }
          }

          let url = "nod-memos";

          let apiMethod = "post";

          let body = {
            datetime: new Date().toISOString(),
          };

          body.nod_case = _nodId;

          const [call, error] = await this.Helper.handlePromise(
            this.API[apiMethod](url, body)
          );

          if (error) {
            console.error(error);

            this.triggerAlert("error", error);
          } else {
            this.memoId = call.data._id;

            await this.uploadFileInput();

            const componentStatus = this.nodStatus;

            componentStatus.memo = true;

            await this.API.put(`nod-cases/${this.nodId}`, {
              componentStatus: componentStatus,
            });

            await this.getMemo(true);

            if (this.filePreview) URL.revokeObjectURL(this.filePreview);
            this.filePreview = null;

            this.fileInput = null;

            this.triggerAlert(
              "success",
              "Memo uploaded",
              "componentIsCompleted",
              this.memoId
            );
          }

          this.Helper.toggleLoadingSpinner(false);
        }
      });
    },
    async uploadFileInput() {
      return new Promise(async (resolve, reject) => {
        let fileModels = {
          ref: "nod-memo",
          refId: this.memoId,
          field: "attachment",
          files: "",
        };

        const formData = new FormData();
        Object.keys(fileModels).forEach((key) => {
          if (key != "files") {
            formData.append(key, fileModels[key]);
          } else {
            formData.append("files", this.fileInput, this.fileInput.name);
          }
        });

        const [call, error] = await this.Helper.handlePromise(
          this.API.postForm("upload", formData)
        );

        if (error) {
          return reject(error);
        } else {
          return resolve("OK");
        }
      });
    },
    triggerAlert(icon, text, callback, callbackData) {
      Swal.fire({
        icon: icon,
        title: `<h5>${text}</h5>`,
      }).then(() => {
        if (callback) {
          this.$emit(callback, callbackData);
        }
      });
    },
    addImage() {
      const input = document.createElement("input");

      input.type = "file";

      input.multiple = true;

      input.accept = "application/pdf";

      input.onchange = this.fileChanged;

      input.click();
    },
    fileChanged(e) {
      const files = e.target.files;
      if (!files || !files.length) return;

      Object.values(files).forEach((file) => {
        if (this.filePreview) URL.revokeObjectURL(this.filePreview);
        this.fileInput = file;
        this.filePreview = URL.createObjectURL(file);
      });

      this.Helper.successToast("Memo PDF added");
    },
    async getMemo(isSilent) {
      if (this.memoId) {
        if (!isSilent) {
          this.Helper.toggleLoadingSpinner(true);
        }

        const [call, error] = await this.Helper.handlePromise(
          this.API.get(`nod-memos/${this.memoId}`)
        );

        if (error) {
          this.triggerAlert("error", "Error getting memo data");
        } else {
          this.memo = call.data;
        }

        if (!isSilent) {
          this.Helper.toggleLoadingSpinner(false);
        }
      }
    },
  },
  mounted() {
    this.memoId = this.componentId;

    this.getMemo();
  },
};
</script>